import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { CircleNotch, MagnifyingGlass } from '@phosphor-icons/react';
import API_URL from '../config';

export const MattersToAddCheck = () => {
  const [st, setSt] = useState(null);
  const [open, setOpen] = useState(false);
  const timer = useRef(null);

  // `since` = server start time from the POST; keep polling until status catches up to it.
  const poll = async (since = null) => {
    try {
      const res = await axios.get(`${API_URL}/api/admin/discover-matters/dry-run`);
      setSt(res.data);
      const stale = since && (!res.data.started_at || new Date(res.data.started_at) < new Date(since));
      if (res.data.running || stale) timer.current = setTimeout(() => poll(since), 2000);
    } catch (e) { /* status poll is best-effort */ }
  };
  useEffect(() => { poll(); return () => clearTimeout(timer.current); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const start = async () => {
    try {
      const res = await axios.post(`${API_URL}/api/admin/discover-matters/dry-run`, {});
      setOpen(true);
      clearTimeout(timer.current);
      poll(res.data.started_at || null);
    } catch (e) { toast.error('Could not start the dry run'); }
  };

  const r = st?.result;
  return (
    <div className="relative">
      <button onClick={start} disabled={st?.running} className="btn-secondary flex items-center gap-2 disabled:opacity-60"
        data-testid="matters-to-add-dryrun-btn" title="Read-only: count the matters the next HubSpot sync would add">
        {st?.running ? <CircleNotch weight="bold" className="w-4 h-4 animate-spin" /> : <MagnifyingGlass weight="bold" className="w-4 h-4" />}
        {st?.running ? `Checking ${st.done}/${st.total || '…'}` : 'Matters to add (dry run)'}
      </button>
      {open && !st?.running && r && (
        <div className="absolute right-0 mt-2 w-96 max-h-96 overflow-auto bg-white border border-[#E4E4E7] shadow-lg p-4 z-20 text-sm"
          data-testid="matters-to-add-result">
          <div className="flex justify-between items-start">
            <p className="font-bold" style={{ color: '#141b4d' }} data-testid="matters-to-add-summary">
              Next sync would add {r.would_add} matter(s) ({r.unfiled} not yet filed) for {r.clients_affected} of {r.processed} client(s).
            </p>
            <button onClick={() => setOpen(false)} className="text-xs ml-2" data-testid="matters-to-add-close">Close</button>
          </div>
          <p className="text-xs mt-1" style={{ color: '#71717A' }}>Dry run — nothing was changed.</p>
          <ul className="mt-3 space-y-1">
            {r.clients.map((c) => (
              <li key={c.email}><span className="font-semibold">{c.name}</span> — {c.marks.join(', ')}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};
